import { useState, useMemo } from "react";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { SupabaseTableEnum } from "@/lib/supabase/supabaseTypes";
import { supabase } from "@/lib/supabase";
import { useCentralStore } from "../../store/Central";
import { Logger } from "@/lib/logger/Logger";
import {
	SheetContentType,
	useSheetStore,
} from "../../store/Sheets/sheet.store";
import { ArticleForm } from "./article-form.component";
import { showNotification } from "../../store/Central/selectors";
import { Plus } from "lucide-react";
import { Button } from "../../components/ui/button";
export const ArticleDialog = () => {
	const [open, setOpen] = useState(false);

	const defaultValues = useMemo(() => ({}), []);
	const openSheet = useSheetStore((state) => state.openSheet);
	const { organization, getArticles } = useCentralStore((state) => ({
		organization: state.organization,
		getArticles: state.getArticles,
	}));

	const methods = useForm({
		defaultValues,
	});

	const handleCreateArticle = async (data: any) => {
		if (!organization) {
			Logger.error("Organization not found in TariffDialog");
			return;
		}
		const { data: newArticle, error } = await supabase
			.from(SupabaseTableEnum.ARTICLES)
			.insert({
				...data,
				organization_id: organization.id,
			})
			.select()
			.single();
		if (error) {
			Logger.error(
				JSON.stringify({ error, data }),
				{
					identifier: "create_article",
				},
				"Error creating article"
			);
			showNotification({
				message: "Fehler beim Erstellen des Artikels",
				type: "error",
			});
			return;
		}
		await getArticles();
		setOpen(false);
		showNotification({
			message: "Artikel erfolgreich erstellt",
			type: "success",
		});
		openSheet(SheetContentType.ARTICLE, { articleId: newArticle.id });
	};

	// Reset the form each time the dialog opens
	const handleOpen = () => {
		methods.reset(defaultValues);
		setOpen(true);
	};

	return (
		<>
			<Button
				variant="outline"
				size="sm"
				icon={<Plus />}
				shortcut="n"
				onClick={handleOpen}
				aria-label="Neuen Artikel erstellen"
				data-testid="new-article-button"
			>
				Neuer Artikel
			</Button>
			<Dialog
				open={open}
				onClose={() => setOpen(false)}
				fullWidth
				maxWidth="md"
			>
				<DialogContent>
					{open && (
						<FormProvider {...methods}>
							<ArticleForm onSubmit={handleCreateArticle} />
						</FormProvider>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setOpen(false)}>Abbrechen</Button>
					<Button
						onClick={methods.handleSubmit(handleCreateArticle)}
						color="primary"
					>
						Speichern
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
